import { default as AdvancedShopperProfile } from '../assets/advanced-shopper-profile.svg?react';
import { default as AdvancedTrendedMetricsScorecard } from '../assets/advanced-trended-metrics-scorecard.svg?react';
import { default as BasketAffinity } from '../assets/basket-affinity.svg?react';
import { default as BasketIDFetch } from '../assets/basket-id-fetch.svg?react';
import { default as Binder } from '../assets/binder.svg?react';
import { default as BrandCircuits } from '../assets/brand-circuits.svg?react';
import { default as BrandDiagnostics } from '../assets/brand-diagnostics.svg?react';
import { default as BrandRadar } from '../assets/brand-radar.svg?react';
import { default as BrandStrength } from '../assets/brand-strength.svg?react';
import { default as BrandTree } from '../assets/brand-tree.svg?react';
import { default as BricksClicks } from '../assets/bricks-clicks.svg?react';
import { default as BuyerLoyaltyFlow } from '../assets/buyer-loyalty-flow.svg?react';
import { default as CategoryStrategy } from '../assets/category-strategy.svg?react';
import { default as CategoryWatch } from '../assets/category-watch.svg?react';
import { default as ConsecutivePurchasing } from '../assets/consecutive-purchasing.svg?react';
import { default as ContentInsights } from '../assets/content-insights.svg?react';
import { default as CountReport } from '../assets/count-report.svg?react';
import { default as CrossPurchase } from '../assets/cross-purchase.svg?react';
import { default as CustomerLifetimeValue } from '../assets/customer-lifetime-value.svg?react';
import { default as Dashboard } from '../assets/dashboard.svg?react';
import { default as DataExplorer } from '../assets/data-explorer.svg?react';
import { default as DemographicsProfile } from '../assets/demographics-profile.svg?react';
import { default as EarlyRead } from '../assets/early-read.svg?react';
import { default as EBSOVA } from '../assets/ebsova.svg?react';
import { default as EventAnalysis } from '../assets/event-analysis.svg?react';
import { default as ExternalLink } from '../assets/external-link.svg?react';
import { default as GenericPlaceholder } from '../assets/generic-placeholder.svg?react';
import { default as HelpCenter } from '../assets/help-center.svg?react';
import { default as HighMedLow } from '../assets/high-med-low.svg?react';
import { default as HouseholdAffinity } from '../assets/household-affinity.svg?react';
import { default as LapsedRepeatNew } from '../assets/lapsed-repeat-new.svg?react';
import { default as LeakageTree } from '../assets/leakage-tree.svg?react';
import { default as MediaConsumption } from '../assets/media-consumption.svg?react';
import { default as Messenger } from '../assets/messenger.svg?react';
import { default as MomentsOfTruth } from '../assets/moments-of-truth.svg?react';
import { default as NewBuyersAnalysis } from '../assets/new-buyers-analysis.svg?react';
import { default as NewItemSovaV2 } from '../assets/new-item-sova-v2.svg?react';
import { default as NewItemSova } from '../assets/new-item-sova.svg?react';
import { default as NewItemTracker } from '../assets/new-item-tracker.svg?react';
import { default as NumeratorUniversity } from '../assets/numerator-university.svg?react';
import { default as OmnicharacteristicsCoverageExplorer } from '../assets/omnicharacteristics-coverage-explorer.svg?react';
import { default as OnlineInterests } from '../assets/online-interests.svg?react';
import { default as OrderDelivery } from '../assets/order-delivery.svg?react';
import { default as PanelSize } from '../assets/panel-size.svg?react';
import { default as PeopleExplorer } from '../assets/people-explorer.svg?react';
import { default as PeopleScorecard } from '../assets/people-scorecard.svg?react';
import { default as PlacementInsights } from '../assets/placement-insights.svg?react';
import { default as PlacementMetrics } from '../assets/placement-metrics.svg?react';
import { default as PointOfEntry } from '../assets/point-of-entry.svg?react';
import { default as PortfolioExplorer } from '../assets/portfolio-explorer.svg?react';
import { default as PortfolioOptimizer } from '../assets/portfolio-optimizer.svg?react';
import { default as PremiumPeopleProfile } from '../assets/premium-people-profile.svg?react';
import { default as ProductHierarchyExplorer } from '../assets/product-hierarchy-explorer.svg?react';
import { default as PromoBrandSwitching } from '../assets/promo-brand-switching.svg?react';
import { default as PromoDrivers } from '../assets/promo-drivers.svg?react';
import { default as PromoOptimization } from '../assets/promo-optimization.svg?react';
import { default as PromoShopperConversion } from '../assets/promo-shopper-conversion.svg?react';
import { default as PromoStoreSwitching } from '../assets/promo-store-switching.svg?react';
import { default as PromotionEffectiveness } from '../assets/promotion-effectiveness.svg?react';
import { default as PromotionScorecard } from '../assets/promotion-scorecard.svg?react';
import { default as Psychographics } from '../assets/psychographics.svg?react';
import { default as PurchaseJourney } from '../assets/purchase-journey.svg?react';
import { default as RetailerCircularAnalysis } from '../assets/retailer-circular-analysis.svg?react';
import { default as RetailerPeopleScorecard } from '../assets/retailer-people-scorecard.svg?react';
import { default as RetailerScorecard } from '../assets/retailer-scorecard.svg?react';
import { default as RetailerShareWallet } from '../assets/retailer-share-wallet.svg?react';
import { default as ShareExplorer } from '../assets/share-explorer.svg?react';
import { default as ShareStomach } from '../assets/share-stomach.svg?react';
import { default as ShopperComparison } from '../assets/shopper-comparison.svg?react';
import { default as ShopperHistogram } from '../assets/shopper-histogram.svg?react';
import { default as ShopperMetrics } from '../assets/shopper-metrics.svg?react';
import { default as ShopperProfile } from '../assets/shopper-profile.svg?react';
import { default as ShopperSentiment } from '../assets/shopper-sentiment.svg?react';
import { default as StoreDiagnostics } from '../assets/store-diagnostics.svg?react';
import { default as StoreHierarchyExplorer } from '../assets/store-hierarchy-explorer.svg?react';
import { default as StoreLoyaltyFlow } from '../assets/store-loyalty-flow.svg?react';
import { default as SystemStatus } from '../assets/system-status.svg?react';
import { default as TrendedMetrics } from '../assets/trended-metrics.svg?react';
import { default as TrialRepeat } from '../assets/trial-repeat.svg?react';
import { default as TripCircuits } from '../assets/trip-circuits.svg?react';
import { default as TripFeedback } from '../assets/trip-feedback.svg?react';
import { default as TripTypeProfile } from '../assets/trip-type-profile.svg?react';
import { default as UserIDFetch } from '../assets/user-id-fetch.svg?react';

/**
 * gets report icon based on id
 * @param  {String} id
 * @return {Node}   react component
 */
export const getReportIcon = (id) => {
  switch (id) {
    case 'advanced-shopper-profile':
      return <AdvancedShopperProfile />;
    case 'advanced-trended-metrics-scorecard':
      return <AdvancedTrendedMetricsScorecard />;
    case 'basket-affinity':
      return <BasketAffinity />;
    case 'basket-id-fetch':
      return <BasketIDFetch />;
    case 'binder':
      return <Binder />;
    case 'brand-circuits':
      return <BrandCircuits />;
    case 'brand-diagnostics':
      return <BrandDiagnostics />;
    case 'brand-radar':
      return <BrandRadar />;
    case 'brand-strength':
      return <BrandStrength />;
    case 'brand-tree':
      return <BrandTree />;
    case 'bricks-clicks':
      return <BricksClicks />;
    case 'buyer-loyalty-flow':
      return <BuyerLoyaltyFlow />;
    case 'category-strategy':
      return <CategoryStrategy />;
    case 'category-watch':
      return <CategoryWatch />;
    case 'consecutive-purchasing':
      return <ConsecutivePurchasing />;
    case 'content-insights':
      return <ContentInsights />;
    case 'count-report':
      return <CountReport />;
    case 'cross-purchase':
      return <CrossPurchase />;
    case 'customer-lifetime-value':
      return <CustomerLifetimeValue />;
    case 'dashboard':
      return <Dashboard />;
    case 'dashboards-numerator-university':
    case 'data-literacy-numerator-university':
    case 'insights-101-numerator-university':
    case 'survey-101-numerator-university':
    case 'survey-help-center':
    case 'survey-product-page-numerator-university':
      return <NumeratorUniversity />;
    case 'data-explorer':
      return <DataExplorer />;
    case 'demographics-profile':
      return <DemographicsProfile />;
    case 'early-read':
      return <EarlyRead />;
    case 'ebsova':
      return <EBSOVA />;
    case 'event-analysis':
      return <EventAnalysis />;
    case 'external-link':
      return <ExternalLink />;
    case 'generic-placeholder':
      return <GenericPlaceholder />;
    case 'heavy-medium-light':
      return <HighMedLow />;
    case 'help-center':
      return <HelpCenter />;
    case 'high-med-low':
      return <HighMedLow />;
    case 'household-affinity':
      return <HouseholdAffinity />;
    case 'lapsed-repeat-new':
      return <LapsedRepeatNew />;
    case 'leakage-tree':
      return <LeakageTree />;
    case 'media-consumption':
      return <MediaConsumption />;
    case 'messenger':
      return <Messenger />;
    case 'moments-of-truth':
      return <MomentsOfTruth />;
    case 'new-buyers-analysis':
      return <NewBuyersAnalysis />;
    case 'new-item-sova':
      return <NewItemSova />;
    case 'new-item-sova-v2':
      return <NewItemSovaV2 />;
    case 'new-item-tracker':
      return <NewItemTracker />;
    case 'numerator-university':
      return <NumeratorUniversity />;
    case 'omnicharacteristics-coverage-explorer':
      return <OmnicharacteristicsCoverageExplorer />;
    case 'online-interests':
      return <OnlineInterests />;
    case 'order-delivery':
      return <OrderDelivery />;
    case 'panel-size':
      return <PanelSize />;
    case 'people-explorer':
      return <PeopleExplorer />;
    case 'people-scorecard':
      return <PeopleScorecard />;
    case 'placement-insights':
      return <PlacementInsights />;
    case 'placement-metrics':
      return <PlacementMetrics />;
    case 'point-of-entry':
      return <PointOfEntry />;
    case 'portfolio-engagement':
      return <NewBuyersAnalysis />;
    case 'portfolio-explorer':
      return <PortfolioExplorer />;
    case 'portfolio-optimizer':
      return <PortfolioOptimizer />;
    case 'premium-people-profile':
      return <PremiumPeopleProfile />;
    case 'product-hierarchy-explorer':
      return <ProductHierarchyExplorer />;
    case 'promo-brand-switching':
      return <PromoBrandSwitching />;
    case 'promo-drivers':
      return <PromoDrivers />;
    case 'promo-optimization':
      return <PromoOptimization />;
    case 'promo-shopper-conversion':
      return <PromoShopperConversion />;
    case 'promo-store-switching':
      return <PromoStoreSwitching />;
    case 'promotion-effectiveness':
      return <PromotionEffectiveness />;
    case 'promotion-scorecard':
      return <PromotionScorecard />;
    case 'psychographics':
      return <Psychographics />;
    case 'purchase-journey':
      return <PurchaseJourney />;
    case 'retailer-circular-analysis':
      return <RetailerCircularAnalysis />;
    case 'retailer-people-scorecard':
      return <RetailerPeopleScorecard />;
    case 'retailer-scorecard':
      return <RetailerScorecard />;
    case 'retailer-share-wallet':
      return <RetailerShareWallet />;
    case 'share-explorer':
      return <ShareExplorer />;
    case 'share-stomach':
      return <ShareStomach />;
    case 'shopper-comparison':
      return <ShopperComparison />;
    case 'shopper-histogram':
      return <ShopperHistogram />;
    case 'shopper-metrics':
      return <ShopperMetrics />;
    case 'shopper-profile':
      return <ShopperProfile />;
    case 'shopper-sentiment':
      return <ShopperSentiment />;
    case 'store-diagnostics':
      return <StoreDiagnostics />;
    case 'store-hierarchy-explorer':
      return <StoreHierarchyExplorer />;
    case 'store-loyalty-flow':
      return <StoreLoyaltyFlow />;
    case 'system-status':
      return <SystemStatus />;
    case 'trended-metrics':
      return <TrendedMetrics />;
    case 'trial-repeat':
      return <TrialRepeat />;
    case 'trip-circuits':
      return <TripCircuits />;
    case 'trip-feedback':
      return <TripFeedback />;
    case 'trip-type-profile':
      return <TripTypeProfile />;
    case 'user-id-fetch':
      return <UserIDFetch />;
    default:
      return <GenericPlaceholder />;
  }
};
